import LazyLoad from 'react-lazyload';
import * as styles from './styles/styles.module.scss';
import useImage from '../../../../../hooks/useImage';

export type Props = {
  imgSrc: string;
  title: string;
  subtext: string;
  url: string;
};

const SeoTabCard = ({ imgSrc, title, subtext, url }: Props) => {
  const [img, updateImageUrl] = useImage(imgSrc);

  return (
    <a href={url}>
      <div className={styles.container}>
        <LazyLoad>
          <img src={img} alt="" onError={() => updateImageUrl()} className={styles.image} />
        </LazyLoad>
        <div>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtext}>{subtext}</div>
        </div>
      </div>
    </a>
  );
};

export default SeoTabCard;
